import React from 'react';
import { describe } from '@elliemae/ds-props-helpers';
import QueryBuilderImpl from './components/QueryBuilderImpl.js';
import {
  QB_EXPORT_FORMAT_TYPES,
  QB_ADD_FILTER_METHOD_TYPES,
  QB_GROUP_FILTER_METHOD_TYPES,
} from './components/helpers/types.js';
import QueryBuilderFormat from './components/format/format.js';
import { props } from './propTypes.js';

const noop = () => null;
const DSQueryBuilder = ({
  containerProps = {},
  addFilterMethod = QB_ADD_FILTER_METHOD_TYPES.IN_PLACE,
  groupFilterMethod = QB_GROUP_FILTER_METHOD_TYPES.IN_PLACE,
  onChange = noop,
  fields = [],
  fieldsSharedActions = {
    onFieldChange: [],
    onOperatorChange: [],
    onValueChange: [],
  },
  format = QB_EXPORT_FORMAT_TYPES.DEFAULT,
  init = null,
  ruleContainerClassName = '',
  handleDrop = noop,
  handleDropFilter = noop,
  handleDropGroup = noop,
  handleFieldChange = noop,
  handleRuleContainerOperator = noop,
  handleRuleContainerUnGroup = noop,
  onAddFilter = noop,
  onAddRuleContainer = noop,
  onRemoveFilter = noop,
  // @ts-expect-error - QueryBuilder was never typescript compliant and won't ever realistically be
  displayFixedOutput,
  displayOutput = false,
  displayOutputLabel = {
    show: 'Show output',
    hide: 'Hide output',
  },
  singleRow = false,
  toolTipZIndex = 110,
}) => (
  <QueryBuilderImpl
    // @ts-expect-error - QueryBuilder was never typescript compliant and won't ever realistically be
    addFilterMethod={addFilterMethod}
    containerProps={containerProps}
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    displayFixedOutput={displayFixedOutput}
    displayOutput={displayOutput}
    displayOutputLabel={displayOutputLabel}
    fields={fields}
    fieldsSharedActions={fieldsSharedActions}
    format={format}
    groupFilterMethod={groupFilterMethod}
    handleDrop={handleDrop}
    handleDropFilter={handleDropFilter}
    handleDropGroup={handleDropGroup}
    handleFieldChange={handleFieldChange}
    handleRuleContainerOperator={handleRuleContainerOperator}
    handleRuleContainerUnGroup={handleRuleContainerUnGroup}
    init={init}
    onAddFilter={onAddFilter}
    onAddRuleContainer={onAddRuleContainer}
    onChange={onChange}
    onRemoveFilter={onRemoveFilter}
    ruleContainerClassName={ruleContainerClassName}
    singleRow={singleRow}
    toolTipZIndex={toolTipZIndex}
  />
);

DSQueryBuilder.displayName = 'DSQueryBuilder';
const DSQueryBuilderWithSchema = describe(DSQueryBuilder);
// @ts-expect-error - QueryBuilder was never typescript compliant and won't ever realistically be
DSQueryBuilderWithSchema.propTypes = props;

export { QueryBuilderFormat, DSQueryBuilderWithSchema, DSQueryBuilder };
export default DSQueryBuilder;
